import pda from './pda'
import web from './web'
import app from './app'

export default [...web, ...pda, ...app]